import { Text, Box, Flex, Grid } from '@chakra-ui/react'
import { AddonDescriptionProps, OfferPackage, OfferPackageSettingsFormProps, OfferProperty, OfferPropertyAddition, OfferTravel, OfferTravelAddition, PackageItemModel, PartPackage } from 'BrokerTsLib/src/dtos'
import { useMemo, useState } from 'react'
import { OfferSettingsModal } from './components/OfferSettingsModal'
import { useGetOfferAvailableAddons } from '../../../hooks/useOffer'
import { AddonCheckbox } from './offerPackageSettingFormItems/AddonCheckbox'
import { LabelHintIcon } from '../../../icons'
import { useSaveOfferAddons } from '../../../hooks/useOfferPackage'
import { FormProvider, useForm } from 'react-hook-form'
import { useApp } from '../../../hooks/useApp'


export const FormRow = ({ label, children }: { label: React.ReactNode, children: React.ReactNode }) => {
  return (
    <Grid
      sx={{
        w: '100%',
        gridTemplateColumns: 'auto 1fr',
        justifyContent: 'start',
        justifyItems: 'start',
      }}
    >
      {label}

      <Flex sx={{ gap: 4 }}>{children}</Flex>
    </Grid>
  )
}


export const OfferPackageSettingsForm = ({ onSuccess, onClose, offer, isOpen, title, isReadOnly }: OfferPackageSettingsFormProps) => {
  const { app } = useApp()
  const { data } = useGetOfferAvailableAddons(offer.offerId)
  const [changedRisks, setChangedRisks] = useState<{ [x: number]: PartPackage }>([])
  const { mutateAsync: saveOfferAddons, isLoading: isLoading } = useSaveOfferAddons()

  const addons = (data?.data ?? []) as PackageItemModel[]
  const [addonDescription, setAddonDescription] = useState<AddonDescriptionProps | null>(null)

  // prazdny objekt pro ostatni, aby bylo mozne pouzit komponentu pro vice produktu nez jen majetek
  const dv = useMemo(() => {
    if (app == 'chaloupka')
      return (offer as OfferProperty).additionData

    if (app == 'cestovko')
      return (offer as OfferTravel).additionData

    return {}
  }, [app, offer])

  const methods = useForm<OfferPropertyAddition | OfferTravelAddition | {}>({
    defaultValues: dv
  })

  const {
    handleSubmit
  } = methods

  const submitForm = handleSubmit((values) => {
    const addons = Object.keys(changedRisks).map(x => changedRisks[x as any])

    return saveOfferAddons({
      offerId: offer.offerId,
      addons: addons,
      additionData: values
    })
      .then(() => {
        onClose()
        onSuccess && onSuccess()

      })
  })

  return (
    <FormProvider {...methods}>
      <form onSubmit={submitForm}>

        <OfferSettingsModal
          title={title}
          isOpen={isOpen}
          isLoading={isLoading}
          isReadOnly={isReadOnly}
          onClose={() => {
            onClose()
            methods.reset()
          }}
          onSubmit={submitForm}
        >

          <Grid
            sx={{
              gridTemplateColumns: '1fr 1fr',
              my: 4,
              h: '100px'
            }}
          >

            {addonDescription &&
              <>
                <Text fontWeight='bold'>
                  {addonDescription.label}
                </Text>

                <Text fontWeight='bold' ml='auto'>
                  {addonDescription.value}
                </Text>

                <Box
                  sx={{ gridColumn: 'span 2' }}
                  fontSize='sm'
                  overflow='auto'
                >
                  {addonDescription.description}
                </Box>
              </>
            }

            {!addonDescription &&
              <Box
                sx={{
                  display: 'flex',
                  gridColumn: 'span 2',
                  gap: 1
                }}
                alignItems='center'
              >
                <LabelHintIcon color='gray.400' />
                <Text fontSize='lg' color='gray.400'>
                  Najetím myší na doplněk zde zobrazíte blížší informace
                </Text>
              </Box>
            }

          </Grid>

          <Grid
            w='100%'
            // gap={4}
            onMouseLeave={() => setAddonDescription(null)}
          >
            {addons.map(x => {
              return (
                <AddonCheckbox
                  key={x.riskId}
                  disabled={isReadOnly}
                  offer={offer}
                  changedPart={changedRisks[x.packageItemId!]}
                  onHover={(ad) => setAddonDescription(ad)}
                  onChange={(checked, limit, packageItemVariantId) => {
                    //const parts = offer.parts.filter(op => op.packageItem.packageItemId == x.packageItemId)                    
                    setChangedRisks({
                      ...changedRisks,
                      [x.packageItemId!]: {
                        //...parts.length == 1 ? parts[0] : {}, // pokud je vice partu k danemu packageItemId, tak chci at se tyka vsech - neposilam tedy zadnou konkretni
                        packageItem: x,
                        packageItemVariantId: packageItemVariantId,
                        limit: limit,
                        included: checked,
                        riskId: x.riskId
                      } as PartPackage
                    })
                  }}
                  addon={x}
                />
              )
            })}
          </Grid>
        </OfferSettingsModal>
      </form>
    </FormProvider>
  )
}